export const project = {
  id: '',
  name: '',
  description: '',
  startDate: '',
  endDate: '',
};
export const typeLocality = {
  id: '',
  name: '',
  description: '',
};

export const locality = {
  id: '',
  name: '',
  description: '',
  typeLocality: typeLocality,
};
export const activity = {
  id: '',
  name: '',
};
export const natureProduct = {
  id: '',
  name: '',
  description: '',
  activity: activity,
};

export const unit = {
  id: '',
  name: '',
  description: '',
  value: '',
};

export const natureCharge = {
  id: '',
  name: '',
  description: '',
  activity: activity,
};

export interface User {
  id: '';
  username: '';
  nom: '';
  prenom: '';
  email: '';
}
export type Activity = {
  id: number;
  name: string;
};

export type SubActivity = {
  id: number;
  name: string;
  activity: Activity;
};

export type Practice = {
  id: number;
  name: string;
  description: string;
  active: boolean;
};

export const practice = {
  id: '',
  name: '',
  description: '',
  active: true,
};

export interface ITpe {
  id?: number;
  code: string;
  type: string;
  name: string;
  genre: string;
  anneeCreation: string;
  nbrActif: number;
  nbrMember: number;
  nbrWomen: number;
  project?: any;
  village?: any;
  commune?: any;
  agroecoloscores?: IAgroecoloscore[];
}

export interface ICommune {
  id: number;
  name: string;
}

export interface IVillage {
  id: number;
  name: string;
  code?: string;
}

export interface IAgroecoloscore {
  id?: number;
  rate: number;
  rating_date: string;
  idSynchro?: string;
}
export interface IProductionCycle {
  id: number;
  label: string;
  startDate: Date | null;
  endDate: Date | null;
  mode: ProductionModes;
  subActivity?: SubActivity;
  production?: any;
  tpe?: ITpe;
  active?: boolean;
  dimension: number;
  previousCrop?: string | null;
  idSynchro: string;
  pratiques?: any[];
  productivites?: any[];
  charges?: any[];
  produits?: any[];
}

export enum ProductionModes {
  conventionnel = 'conventionnel',
  agroécologie = 'agroécologie',
}
